import React from "react";
import dish1 from "../assets/dish-1.png";

function About() {
  return (
    <duv className="">
      <div className="flex grid grid-cols-1 sm:grid-cols-3 justify-center items-center">
        <div className="hidden sm:block col-span-2 flex justify-start items-start">
          <img src={dish1} />
        </div>
        <div className="space-y-8">
          <h1 className="text-4xl tracking-wider font-bold">
            <span className="border-b-4 border-green-800">About</span> Foodie
          </h1>

          <p className="text-gray-400 text-left">
            Pellentesque habitant morbi tristique senectus et. morbi tristique
            senectus et.
          </p>

          <div>
            <ul className="space-y-4 flex flex-col items-start justify-start">
              <li className="inline-flex items-center justify-center space-x-4">
                <div className="bg-gray-200 p-6 rounded-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8 text-gray-700"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                  </svg>
                </div>
                <div className="flex flex-col items-start justify-start">
                  <p className="text-gray-900 text-left font-bold">
                    Pellentesque
                  </p>
                  <p className="text-gray-400 text-sm text-left">
                    Pellentesque habitant morbi tristique senectus et.
                  </p>
                </div>
              </li>
              <li className="inline-flex items-center justify-center space-x-4">
                <div className="bg-gray-200 p-6 rounded-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8 text-gray-700"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    />
                  </svg>
                </div>
                <div className="flex flex-col items-start justify-start">
                  <p className="text-gray-900 text-left font-bold">
                    Consectetur adipisicing
                  </p>
                  <p className="text-gray-400 text-sm text-left">
                    Consectetur adipisicing elit, sed do eiusmod tempor.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <div class="">
              <a
                href="#"
                className="inline-flex justify-between items-center rounded-lg bg-green-800 hover:bg-green-900 text-white py-2 px-8 rounded-full"
              >
                See More
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3 text-white ml-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </duv>
  );
}

export default About;
